export default {
	MOBILE: 320,
	TABLET: 768,
	LAPTOP: 1024,
	DESKTOP: 1280,
	HD: 1440,
	FULLHD: 1920
};
